import React from 'react';
import PropTypes from 'prop-types';

export default function NonEmptyArrayField({
  value, onChange, renderer, defaultValue, errors: errs }) {
  const type = typeof defaultValue;
  const elements = (value.length ? value : [defaultValue]).map((element, idx) => {
    const errors = {};
    const idxStr = `[${idx}]`;
    Object.keys(errs).forEach((key) => {
      if (key.startsWith(idxStr)) {
        if (type === 'string') {
          errors.value = errs[key];
        } else {
          errors[key.substring(idxStr.length + 1)] = errs[key];
        }
      }
    });
    return renderer({
      val: (type === 'string')
        ? { value: element }
        : element,
      getHandler: (fieldName, afterCallback) => {
        return ({ target: { value: fieldValue } }) => {
          const newValue = value.slice();
          let propName;
          if (type === 'string') {
            newValue[idx] = fieldValue;
            propName = idxStr;
          } else {
            newValue[idx] = {
              ...element,
              [fieldName]: fieldValue,
            };
            propName = `${idxStr}.${fieldName}`;
          }
          if (afterCallback) {
            onChange(propName, afterCallback(fieldValue, newValue));
          } else {
            onChange(propName, newValue);
          }
        };
      },
      del: () => {
        const newValue = value.slice();
        newValue.splice(idx, 1);
        onChange('', newValue);
      },
      add: () => {
        const newValue = value.slice();
        newValue.push(defaultValue);
        onChange('', newValue);
      },
      errors,
      idx,
      length: value.length || 1,
      touched: {},
    });
  });
  return (<div>{elements}</div>);
}

NonEmptyArrayField.propTypes = {
  value: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.shape(),
    PropTypes.string,
  ])),
  defaultValue: PropTypes.oneOfType([
    PropTypes.shape(),
    PropTypes.string,
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  renderer: PropTypes.func.isRequired,
  errors: PropTypes.shape(),
};

NonEmptyArrayField.defaultProps = {
  value: [],
  errors: {},
};
